if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        /*if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }*/
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
        this.validateCustomOptions();
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      /*fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }*/

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
      validateCustomOptions() {
        const productForms = document.querySelectorAll('[id^="product-form-"]');
        productForms.forEach(form => {
            form.removeAttribute("novalidate");
        });
      }
    }
  );
}

if (!customElements.get('product-description-layout')) {
  customElements.define(
    'product-description-layout',
    class ProductDescriptionLayout extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.placeholder = document.createComment('product-description-mobile-position');
        this.parentNode.insertBefore(this.placeholder, this);
        this.desktopSlot = document.querySelector(
          `[data-product-description-desktop-slot="${this.dataset.sectionId}"]`
        );
        this.desktopToggle = this.querySelector('[data-product-description-desktop-toggle]');
        this.showLessLabel = this.querySelector('[data-product-description-show-less]');
        this.showMoreLabel = this.querySelector('[data-product-description-show-more]');
        this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
        this.handleViewportChange = this.updateLayout.bind(this);
        this.handleDesktopToggle = this.toggleDesktopDescription.bind(this);

        this.desktopToggle?.addEventListener('click', this.handleDesktopToggle);
        this.desktopMediaQuery.addEventListener('change', this.handleViewportChange);
        this.updateLayout();
      }

      disconnectedCallback() {
        window.setTimeout(() => {
          if (this.isConnected || !this.initialized) return;
          this.desktopToggle?.removeEventListener('click', this.handleDesktopToggle);
          this.desktopMediaQuery?.removeEventListener('change', this.handleViewportChange);
          this.initialized = false;
        }, 0);
      }

      updateLayout() {
        if (this.desktopMediaQuery.matches && this.desktopSlot) {
          this.classList.remove('is-desktop-collapsed');
          this.updateDesktopToggle(true);
          if (this.parentNode !== this.desktopSlot) this.desktopSlot.appendChild(this);
          return;
        }

        this.classList.remove('is-desktop-collapsed');
        this.updateDesktopToggle(true);
        if (this.placeholder?.parentNode && this.previousSibling !== this.placeholder) {
          this.placeholder.parentNode.insertBefore(this, this.placeholder.nextSibling);
        }
      }

      toggleDesktopDescription() {
        if (!this.desktopMediaQuery.matches) return;
        const isExpanded = !this.classList.toggle('is-desktop-collapsed');
        this.updateDesktopToggle(isExpanded);
      }

      updateDesktopToggle(isExpanded) {
        if (!this.desktopToggle) return;
        this.desktopToggle.setAttribute('aria-expanded', String(isExpanded));
        this.desktopToggle.setAttribute(
          'aria-label',
          (isExpanded ? this.showLessLabel : this.showMoreLabel)?.textContent.trim() || ''
        );
        this.showLessLabel?.classList.toggle('hidden', !isExpanded);
        this.showMoreLabel?.classList.toggle('hidden', isExpanded);
      }
    }
  );
}
